import { useEffect, useRef } from 'react';

import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder';
import { LngLatLike } from 'mapbox-gl';
import '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css';
import './LocationSearch.css';

interface LocationSearchProps {
  onLocationFound: (coords: LngLatLike) => void;
  onClear?: () => void;
  proximity?: { longitude: number; latitude: number };
}

const MAPBOX_TOKEN = 'pk.eyJ1IjoianVsaWFub2VzIiwiYSI6ImNrOGNwbXVzbTA2bnMzZW95bmhvemIwbGkifQ.vHzrkhopow_IrtZm5yP5iA';

export const LocationSearch = ({ onLocationFound, onClear, proximity }: LocationSearchProps) => {
  const geocoderContainerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (geocoderContainerRef.current) {
      const geocoder = new MapboxGeocoder({
        proximity,
        accessToken: MAPBOX_TOKEN,
        types: 'country,region,place,postcode,locality,neighborhood,address'
      });

      geocoder.addTo(geocoderContainerRef.current);

      geocoder.on('result', (e) => {
        onLocationFound(e.result.center);
      });

      geocoder.on('clear', () => {
        if (onClear) {
          onClear();
        }
      });

      return () => {
        // Clean up on unmount
        // The geocoder doesn't have a simple destroy method, so we clear the container
        if (geocoderContainerRef.current) {
          geocoderContainerRef.current.innerHTML = '';
        }
      };
    }
  }, [onLocationFound, onClear, proximity]);

  return <div ref={geocoderContainerRef} style={{ width: '100%' }} />;
};
